import { render, staticRenderFns } from "./BusinessCaseSb.vue?vue&type=template&id=26368393&scoped=true"
import script from "./BusinessCaseSb.vue?vue&type=script&lang=js"
export * from "./BusinessCaseSb.vue?vue&type=script&lang=js"
import style0 from "./BusinessCaseSb.vue?vue&type=style&index=0&id=26368393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26368393",
  null
  
)

export default component.exports